export * from './app-sidebar-minimizer.component';



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-minimizer/index.ts